import React, { useEffect, useRef, useState } from 'react';
import styles from '../../assets/css/celular.module.css';
import stylesTemplate from '../../assets/css/template.module.css';
import data from '../../data/json/celular.json';
import { CiBatteryFull, CiCalendar, CiMenuKebab } from "react-icons/ci";
import { MdVerified } from "react-icons/md";
import { BiSolidFilePdf } from "react-icons/bi";
import { GoDownload } from "react-icons/go";
import { TbMoneybag } from "react-icons/tb";
import { HiCheckCircle } from "react-icons/hi";
import { BsReply } from "react-icons/bs";
import { IoCameraOutline } from "react-icons/io5";
import { AiOutlineAudio, AiOutlineClose } from "react-icons/ai";
import { GrFormPreviousLink } from "react-icons/gr";
import { PiBagSimple } from "react-icons/pi";
import pim from "../../assets/imagens/webp/pim.webp";

import { useLocation } from "react-router-dom";

// modo="simples" → renderiza RenderizarMensagemSimples para qualquer card (usado no Features/page2)
// modo não passado  → lógica original da page com cards hardcoded por ID

const Celular = ({ selectedOption, setAncoraFormulario, pageData, cardList: cardListProp, modo }) => {

  const [activeCardId, setActiveCardId] = useState(1);
  const [showPassos, setShowPassos] = useState(false);
  const [isMostrarForm, setIsMostrarForm] = useState(false);
  const [step, setStep] = useState(0);
  const scrollRef = useRef(null);
  const [isAnimate, setIsAnimate] = useState(false);
  const [cardList, setCardList] = useState([]);

  const location = useLocation();

  useEffect(() => {
    if (cardListProp && cardListProp.length > 0) {
      setCardList(cardListProp);
      setActiveCardId(cardListProp[0]?.id || 1);
      return;
    }

    const isZapMei = location.pathname.includes("/zapmei");
    const newList = isZapMei
      ? data?.page2?.card_1 || []
      : data?.page?.card_1 || [];

    setCardList(newList);
    setActiveCardId(newList[0]?.id || 1);
  }, [location.pathname, cardListProp]);

  const selectedCard = cardList.find(card => card.id === activeCardId) || cardList[0] || {};

  useEffect(() => {
    setShowPassos(false);
  }, [activeCardId]);

  useEffect(() => {
    const timer1 = setTimeout(() => setStep(1), 2000);
    const timer2 = setTimeout(() => setStep(2), 4000);
    return () => { clearTimeout(timer1); clearTimeout(timer2); };
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [step]);

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimate(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const RenderizarMensagemSimples = () => {
    return (
      <div className={styles['phone-content']}>
        <div id={styles['phone-box']}>
          {selectedCard.mensagens?.map((msg) => (
            <section key={msg.id} className={styles['contexto-box']}>
              <strong>{msg.title}</strong>
              <p>{msg.description}</p>

              {activeCardId === 1 ? (
                msg.btn && (
                  <button
                    className={styles['btn']}
                    onClick={() => setShowPassos(true)}
                  >
                    {msg.btn}
                  </button>
                )
              ) : null}
            </section>
          ))}
        </div>
      </div>
    );
  };

  const RenderizarCardsLaterais = () => {
    return (
      cardList.map((card) => (
        <div
          key={card.id}
          onClick={() => setActiveCardId(card.id)}
          className={[
            styles.card,
            styles[card.pos],
            activeCardId === card.id ? styles.active : ''
          ].join(' ')}
        >
          <div className={styles['card-id']}>{card.id}</div>
          <h4>{card.title}</h4>
          <p>{card.description}</p>
        </div>
      ))
    );
  };

  const EstruturaBoxArquivo = ({ title, tamanho }) => {
    return (
      <div className={styles['arquivo']}>
        <div className={styles['type-arquivo']}>
          <BiSolidFilePdf />
        </div>
        <div className={styles['info-arquivo']}>
          <label>{title}</label>
          <span>{tamanho}</span>
        </div>
        <div className={styles['download-icon']}>
          <GoDownload />
        </div>
      </div>
    );
  };

  const Iphone = () => {
    return (
      <div className={styles['style-border-radius']}>
        <div className={styles['display-flex']}>
          <div className={styles['widt-text-center']}>
            <div className={styles['style-camera']}></div>
          </div>
          <div className={styles['battery-icon']}><CiBatteryFull /></div>
        </div>

        <div className={styles['foto-perfil-container']}>
          <div className={styles['foto-perfil']}>
            <img src={pim} alt="Meu Contador Online" className={styles['wid-heig']} />
          </div>
          <div className={styles['perfil-nome']}>
            <label className={styles['color-font']}>
              <a href='https://www.meucontadoronline.com.br/' target="_blank" rel="noopener noreferrer" title="Ir para a página inicial da Meu Contador Online">
                Meu Contador Online
              </a>{' '}
              <MdVerified style={{ color: "#0064ff", fontSize: 18, position: "relative", top: 5 }} />
            </label>
          </div>
        </div>
      </div>
    );
  };

  // Conteúdo do celular no modo "simples" — qualquer card usa RenderizarMensagemSimples
  const RenderConteudoSimples = () => (
    <RenderizarMensagemSimples />
  );

  // Conteúdo do celular no modo original — lógica hardcoded por ID (page padrão)
  const RenderConteudoOriginal = () => (
    <>
      {/* CARD 1 — Emissão de Nota com passos */}
      {activeCardId === 1 && (
        <>
          {!showPassos ? (
            <RenderizarMensagemSimples />
          ) : (
            <div className={styles['box-passos']}>
              <div className={styles['box-title']}>
                <div
                  className={styles['justify-center']}
                  onClick={() => {
                    if (isMostrarForm) {
                      setIsMostrarForm(false);
                    } else {
                      setShowPassos(false);
                    }
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {isMostrarForm ? <GrFormPreviousLink /> : <AiOutlineClose />}
                </div>

                <div className={styles['justify-center']}>
                  <strong>
                    Emissor de Notas Fiscais{' '}
                    <a href='https://www.meucontadoronline.com.br/' target='_blank' rel='noopener noreferrer' title='Ir para a página inicial da Meu Contador Online'>
                      MCO
                    </a>
                  </strong>
                </div>

                <div className={styles['justify-center']}><CiMenuKebab /></div>
              </div>

              {isMostrarForm ? (
                <div>
                  <div className={styles['form']}>
                    <div className={styles['input']}>CPF/CNPJ DO TOMADOR (opcional)</div>
                    <p>Digite o CNPJ da empresa que vai receber o seu serviço - Apenas números</p>

                    <div className={styles['input-textarea']}>Descrição do serviço</div>
                    <p>Escreva um resumo simples e objetivo que descreva o serviço realizado</p>

                    <div className={styles['input']}>Valor do Serviço</div>
                    <p>Valor total do serviço prestado no formato brasileiro, com virgula para centados</p>
                  </div>
                </div>
              ) : (
                selectedCard.passos?.map((passo, index) => (
                  passo.id === 5 ? (
                    <div
                      key={passo.id || index}
                      className={styles['btn-continuar']}
                      onClick={() => setIsMostrarForm(true)}
                      style={{ cursor: 'pointer' }}
                    >
                      <span>{passo.description}</span>
                    </div>
                  ) : (
                    <div key={passo.id || index}>
                      <p>{passo.id} - {passo.description}</p>
                    </div>
                  )
                ))
              )}
            </div>
          )}
        </>
      )}

      {/* CARD 2 — Obrigações fiscais com arquivo */}
      {activeCardId === 2 && (
        <div className={styles['phone-content']}>
          <div id={styles['phone-box']}>
            <EstruturaBoxArquivo title="Obrigações fiscais.pdf" tamanho="89 KB PDF" />
            <section className={styles['contexto-box']}>
              <strong>Olá, tudo bem? </strong>
              <p>
                Segue para você todas as suas guias e obrigações fiscais com todos os detalhes de cada uma para você organizar o seu caixa!
                Se tiver alguma dúvida, não hesite em nos chamar!
              </p>
            </section>
          </div>
        </div>
      )}

      {/* CARDS 3, 5, 6 — Mensagem simples */}
      {(activeCardId === 3 || activeCardId === 5 || activeCardId === 6) && (
        <RenderizarMensagemSimples />
      )}

      {/* CARD 4 — DAS com arquivo */}
      {activeCardId === 4 && (
        <div className={styles['phone-content']}>
          <div id={styles['phone-box']}>
            <EstruturaBoxArquivo title="DAS.pdf" tamanho="285 KB" />
            <section className={styles['contexto-box']}>
              <strong>Olá Aqui é o PIM, Seu Contador Digital do Meu Contador Online.</strong>
              <p>
                Tenho ótimas notícias! Seu documento DAS já está disponível para você cliente <strong>Meu Contador online</strong>, para facilitar sua vida ainda mais, estou te enviando em anexo seu documento.
              </p>
              <strong>Segue abaixo as informações:</strong>
              <p><CiCalendar style={{ position: "relative", top: 2, color: "rgb(0, 100, 255)" }} /> Vencimento: 25/10/2025</p>
              <p><TbMoneybag style={{ position: "relative", top: 2, color: "rgb(0, 100, 255)" }} /> Valor: R$100,00</p>
              <p>
                <HiCheckCircle style={{ position: "relative", top: 2, color: "rgb(0, 100, 255)" }} />{' '}
                <strong style={{ fontSize: 12 }}>Importante lembrar:</strong> Não é necessário me responder. Até Mais!
              </p>
              <p>Escolha a melhor forma para o seu pagamento. Até Mais!!!</p>
              <p style={{ color: "rgb(0, 100, 255)", fontSize: 12 }}><BsReply style={{ position: "relative", top: 2 }} /> Pix</p>
              <p style={{ color: "rgb(0, 100, 255)", fontSize: 12 }}><BsReply style={{ position: "relative", top: 2 }} /> Boleto</p>
            </section>
          </div>
        </div>
      )}
    </>
  );

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className={styles['wrapper']}>
          <div className={styles['cards-container']}>
            <RenderizarCardsLaterais />
          </div>

          <div className={styles['phone-mockup']}>
            <Iphone />

            <div
              ref={scrollRef}
              className={`${styles['scroll-y']} ${activeCardId === 1 ? styles['no-padding'] : ''}`}
              style={{ height: "390px" }}
            >
              {/* Escolhe o modo de renderização */}
              {modo === "simples"
                ? <RenderConteudoSimples />
                : <RenderConteudoOriginal />
              }
            </div>

            {/* TECLADO */}
            <div className={styles['keyboard-container']}>
              <div className={styles['icon-button']}>+</div>
              <div className={styles['input-mock']} />
              <div className={styles['actions-group']}>
                <div className={styles['icon-button']}><IoCameraOutline /></div>
                <div className={styles['icon-button']}><AiOutlineAudio /></div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles['box-explicacao']}>
          <div className={styles['box']}>
            {selectedCard.explicacao || "Selecione um card para ver a explicação."}
          </div>

          <br />

          {selectedOption && (
            <div style={{ display: "block", justifyContent: "center", alignItems: "center" }}>
              <button
                className={stylesTemplate['btn-primary']}
                onClick={() => setAncoraFormulario(true)}
                style={{ marginBottom: 10 }}
              >
                {selectedOption?.descript_btn} <PiBagSimple style={{ fontSize: 25 }} />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Celular;